import angular from 'angular';
import uiRouter from 'angular-ui-router';

import termsOfServiceRoutes from './terms-of-service-routes';

const termsOfService = angular.module('termsOfService', [uiRouter]);
termsOfService.config(termsOfServiceRoutes);

export default termsOfService.name;
